import { useNavigate } from "react-router-dom";
import { Spinner } from "@phosphor-icons/react";

// Shown when the project loader returns 403 — the user is either logged in to
// the wrong account or was never on the distribution list.
export default function ProjectAccessDenied({ isAuthed }) {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen w-full bg-slate-50 flex items-center justify-center px-4">
      <div className="w-full max-w-md bg-white border border-slate-300 rounded-md p-8 text-center">
        <div className="h-11 w-11 rounded-md bg-red-50 text-red-600 flex items-center justify-center mx-auto mb-3">
          <Spinner size={18} weight="bold" />
        </div>
        <div className="font-display text-xl font-black tracking-tight">No access</div>
        <div className="text-sm text-slate-600 mt-2">
          {isAuthed
            ? "This account is not on the distribution list for this project. Ask the admin to add your email."
            : "Your email is not on the distribution list. Ask the admin to add it."}
        </div>
        <button
          onClick={() => navigate(isAuthed ? "/dashboard" : "/")}
          className="mt-5 h-10 px-4 bg-slate-950 hover:bg-slate-800 text-white rounded-md text-sm font-medium"
          data-testid="access-denied-back-btn"
        >
          {isAuthed ? "Back to dashboard" : "Back to home"}
        </button>
      </div>
    </div>
  );
}
